<template>

<div>

	<v-menu v-if="type === 'menu'" offset-y dense>
		<template v-slot:activator="{ on }">
			<v-btn tile block v-on="on">
				{{ $t('compOrdersByTokenPair.myWatchlist') }}
				<v-icon>mdi-chevron-down</v-icon>
			</v-btn>
		</template>
		<v-list dense class="overflow-y-auto" max-height="300">
			<v-list-item v-if="showAddNewTokenPairOption"
				@click="showAddNewTokenPair">
				<v-list-item-title>
					+ {{ $t('compOrdersByTokenPair.addNewTradingPair') }}
				</v-list-item-title>
			</v-list-item>
			<v-list-item
				v-for="tokenPair in trackedTokenPairs"
				:key="tokenPair.tokenA.address + tokenPair.tokenB.address"
				:to="{ name: 'OrdersByTokenPair', params: { makerAssetSymbol: tokenPair.tokenA.symbol, makerAssetAddress: tokenPair.tokenA.address, takerAssetSymbol: tokenPair.tokenB.symbol, takerAssetAddress: tokenPair.tokenB.address } }"
			>
				<v-list-item-title>{{ tokenPair.tokenA.symbol }} - {{ tokenPair.tokenB.symbol }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>

	<div v-if="type === 'chip'">
		<v-chip v-for="tokenPair in trackedTokenPairs"
			:key="tokenPair.tokenA.address + tokenPair.tokenB.address"
			:to="{ name: 'OrdersByTokenPair', params: { makerAssetSymbol: tokenPair.tokenA.symbol, makerAssetAddress: tokenPair.tokenA.address, takerAssetSymbol: tokenPair.tokenB.symbol, takerAssetAddress: tokenPair.tokenB.address } }"
			class="mr-2 mb-1" color="primary"
			>
    	{{ tokenPair.tokenA.symbol }} - {{ tokenPair.tokenB.symbol }}
    </v-chip>
	</div>

</div>

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
	name: 'TrackedTradingPairList',
	props: {
    type: { type: String, default: "menu" }, // 'menu' or 'chip'
    showAddNewTokenPairOption: { type: Boolean, default: false },
  },
	data () {
		return {
			tokenPairOptions: [],
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			myAddress: 'getUserAccount',
			tokenInfo: 'getTokenInfo',
			relayerList: 'getRelayerList',
			relayerInfo: 'getRelayerInfo',
			networkConfig: 'getNetworkConfig',
		}),
		trackedTokenPairs: function () {
			if (this.account.trackedTokenPairs) {
				const list = [ ...this.account.trackedTokenPairs ]
				list.sort((a,b) => {
					if (a.tokenA.symbol > b.tokenA.symbol) {
						return 1
					}
					else if (a.tokenA.symbol < b.tokenA.symbol) {
						return -1
					}
					else {
						if (a.tokenB.symbol > b.tokenB.symbol) {
							return 1
						}
						if (a.tokenB.symbol < b.tokenB.symbol) {
							return -1
						}
					}
				})
				return list
			}
			else {
				return null
			}
		},
	},
	methods: {
		async init () {
		},
		showAddNewTokenPair: function () {
			this.$emit('tracked-token-pair-show-add-new')
		},
	},
	created () {
		// this.init()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
